<template>
  <div class="tw-flex tw-flex-wrap tw-gap-x-4 lg:tw-flex-nowrap">
    <slot />
  </div>
</template>
